import React from 'react';
import { Route, useRouteMatch } from 'react-router-dom';

import { PartnerMapForm } from 'features/cris/partner-map/partner-map-form';
import { PartnerMapListing } from 'features/cris/partner-map/partner-map-listing';

export const PartnerMapRouter: React.FunctionComponent = () => {
    const { path } = useRouteMatch();

    return (
        <React.Fragment>
            <Route exact path={`${path}`}>
                <PartnerMapListing />
            </Route>
            <Route exact path={[`${path}/new`, `${path}/:partMapId`]}>
                <PartnerMapForm />
            </Route>
        </React.Fragment>
    );
};
